import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyCoQpXR6Hn9VMfBWbhG7wNXXXXXXXX",
    authDomain: "tradevu-693b7.firebaseapp.com",
    projectId: "tradevu-693b7888",
    storageBucket: "tradevu-693b7.appspot.com",
    messagingSenderId: "254109337180000",
    appId: "1:254109337180:web:05834ceb6a694b06b648999999",
    measurementId: "G-VD1J2LEPVS",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Google Analytics
const analytics = getAnalytics(app);

export { analytics };
